module.exports = __webpack_public_path__ + "files/ca1b8cf446140c2c6669348c917f97d1.png";